import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-state-caisse',
  templateUrl: './state-caisse.component.html',
  styleUrls: ['./state-caisse.component.scss']
})
export class StateCaisseComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
